export function markdown(body: string): string {
  const lines = body.split(/\r?\n/u);
  const output: string[] = [];
  let list: "ul" | "ol" | null = null;
  let code = false;
  const closeList = () => { if (list) { output.push(`</${list}>`); list = null; } };
  for (const raw of lines) {
    if (raw.trim().startsWith("```")) {
      closeList();
      output.push(code ? "</code></pre>" : "<pre><code>");
      code = !code;
      continue;
    }
    if (code) { output.push(`${escapeHtml(raw)}\n`); continue; }
    if (!raw.trim()) { closeList(); output.push("<div class=\"markdown-gap\"></div>"); continue; }
    const heading = raw.match(/^(#{1,3})\s+(.+)$/u);
    if (heading) {
      closeList();
      const level = heading[1]!.length + 2;
      output.push(`<h${level}>${inlineMarkdown(heading[2]!)}</h${level}>`);
      continue;
    }
    const bullet = raw.match(/^\s*[-*]\s+(.+)$/u);
    const numbered = raw.match(/^\s*\d+[.)]\s+(.+)$/u);
    if (bullet || numbered) {
      const type = bullet ? "ul" : "ol";
      if (list !== type) { closeList(); list = type; output.push(`<${type}>`); }
      output.push(`<li>${inlineMarkdown((bullet ?? numbered)![1]!)}</li>`);
      continue;
    }
    closeList();
    const quote = raw.match(/^>\s?(.*)$/u);
    output.push(quote ? `<blockquote>${inlineMarkdown(quote[1]!)}</blockquote>` : `<p>${inlineMarkdown(raw)}</p>`);
  }
  closeList();
  if (code) output.push("</code></pre>");
  return output.join("");
}

function inlineMarkdown(value: string): string {
  return escapeHtml(value)
    .replace(/`([^`]+)`/gu, "<code>$1</code>")
    .replace(/\*\*([^*]+)\*\*/gu, "<strong>$1</strong>")
    .replace(/__([^_]+)__/gu, "<strong>$1</strong>")
    .replace(/(^|[^*])\*([^*]+)\*/gu, "$1<em>$2</em>")
    .replace(/(^|[^_])_([^_]+)_/gu, "$1<em>$2</em>");
}

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/gu, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  })[character]!);
}
